// default theme type
export let currentTheme: any;
export let locale: any;
var langStore: any = localStorage.getItem("locales");

if (localStorage) {
  currentTheme =
    localStorage.getItem("data-theme") !== null
      ? localStorage.getItem("data-theme")
      : "light";
  locale =
    JSON.parse(langStore) !== null ? JSON.parse(langStore) : { name: "fa" };
}
